import { createContext, ReactNode, useContext, useState } from 'react';
import { ILoginUserDetails } from '../interfaces/User';


type AuthContextType = {
  token: string | null;
  login: (token: string) => void;
  setLoginUser: (info: string) => void;
  getLoginUser: () => string | null;
  getLoginUserInfo: () => ILoginUserDetails | null;
  logout: () => void;
};

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState<string | null>(
    sessionStorage.getItem("token")
  );

  const [loginDetails, setLoginDetails] = useState<string | null>(
    sessionStorage.getItem("loginDetails")
  );

  const login = (newToken: string) => {
    sessionStorage.setItem("token", newToken);
    setToken(newToken);
  };

  const setLoginUser = (info: string) => {
    sessionStorage.setItem("loginDetails", info);
    setLoginDetails(info);
  };

  const getLoginUser = () => {
    return loginDetails;
  };

  const getLoginUserInfo = () => {
    return loginDetails
      ? (JSON.parse(loginDetails) as ILoginUserDetails)
      : null;
  };

  const logout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.clear();
    setToken(null);
  };

  return (
    <AuthContext.Provider
      value={{
        token,
        login,
        logout,
        setLoginUser,
        getLoginUser,
        getLoginUserInfo,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};